import React from 'react';
import { Alert } from '@planne-software/uni';
import { IconAlertTriangle } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

export const RescheduleExpiredAlert = () => {
  const { i18n } = useTranslate();

  return (
    <Alert
      data-testid='reschedule-expired'
      severity='warning'
      canClose={false}
      title={i18n('checkout_confirmed_reschedule_expired')}
      startIcon={<IconAlertTriangle size={20} aria-hidden />}
      sx={{ marginTop: 0, width: '100%' }}
    />
  );
};

export default RescheduleExpiredAlert;
